import React from 'react';
import { useSelector } from 'react-redux';
import { selectStatusTraceDetail } from 'store/Manage/selectors';
import {
  Wrapper, Item, New, Open, Closed, ReOpened,
  CloseIcon, RiskAccepted, Box, Status,
  Info, UserIcon, DateIcon, InfoWrapper,
  User, Date
} from './styled';
import moment from 'moment';
import { useIntl } from 'react-intl';

const TraceItem = ({ data }) => {
  const intl = useIntl();
  const { change_date, status, user } = data;
  const date = moment.parseZone(change_date).local().format('YYYY-MM-DD HH:mm');
  const parsedStatus = intl.formatMessage({ id: `manage.cm.status.${status}` });

  const ICONS = {
    'new': <New />,
    'open': <Open />,
    'closed': <Closed><CloseIcon /></Closed>,
    're-opened': <ReOpened />,
    'risk-accepted': <RiskAccepted />
  };

  return (
    <Item>
      { ICONS[status] }
      <Box>
        <Status>{ parsedStatus }</Status>
        <Info>
          <InfoWrapper>
            <UserIcon />
            <User>{ user || 'System' }</User>
          </InfoWrapper>
          <InfoWrapper>
            <DateIcon />
            <Date>{ date }</Date>
          </InfoWrapper>
        </Info>
      </Box>
    </Item>
  );
};

const StatusTraceTab = ({ entity }) => {
  const statusTrace = useSelector((state) => selectStatusTraceDetail(state, entity));

  return (
    <Wrapper>
      { statusTrace?.map((statusTrace, i) => <TraceItem key={ `${statusTrace.status}-${i}` } data={ statusTrace } />) }
    </Wrapper>
  );
};

export default StatusTraceTab;
